<template>
  <CustomTable
    :columns="columnsTableFields"
    :data="dataTable"
    :is-loading="isLoadingTable"
    :show-checkbox-row="false"
    :skeleton-row-number="1"
    :sort-direction="'asc'"
    :custom-class="'!tw-shadow-none inciden-event-header'"
    :header-wrapper-class="'tw-py-[20px] tw-px-[25px]'"
  >
    <template #cell(date)="value">
      <span
        v-if="!isShowEdit"
        class="tw-text-[13px] tw-text-[#231F20] tw-whitespace-nowrap tw-min-h-[20px]"
      >
        {{
          value.item.incidentStartDate !== "Invalid date" &&
          value.item.incidentStartDate !== null &&
          value.item.incidentStartDate !== undefined
            ? formatDate(value.item.incidentStartDate)
            : ""
        }}
      </span>
      <BFormInput
        v-else
        id="dateIncidenAndEventTable"
        v-model="value.item.incidentStartDate"
        :value="value.item.incidentStartDate"
        class="input-date-item"
        type="date"
        :placeholder="
          getComponentUiText(
            'app-scanning-schedule-modal-select-date-placeholder-1',
          )
        "
        @input="hasChanged(value.item)"
      />
    </template>

    <template #cell(event)="value">
      <span
        v-if="!isShowEdit"
        class="tw-text-[13px] tw-text-[#231F20] tw-whitespace-nowrap tw-min-h-[20px]"
      >
        {{ getEventFormId(value.item.incidentTypeId) }}
      </span>
      <BaseDropDown
        v-else
        :id="'eventIncidenAndEventTable'"
        :model-value="value.item.incidentTypeId"
        :data="checklistIncidentType"
        :class-name="'gray-dropdown-container tw-h-[44px] is-inciden-event-table'"
        @update:model-value="
          (valueItem) => updateValue(valueItem, value.item, 'incidentTypeId')
        "
      />
    </template>

    <template #cell(description)="value">
      <div class="tw-flex tw-gap-[10px]">
        <span
          v-if="!isShowEdit"
          class="tw-text-[13px] tw-text-[#231F20] tw-min-h-[20px]"
        >
          {{ value.item.incidentDescription }}
        </span>
        <input
          v-else
          id="input-rename"
          v-model="value.item.incidentDescription"
          type="text"
          class="tw-border tw-border-solid tw-border-[#EFF0F1] tw-p-[12px] tw-pr-[45px] tw-text-[13px] tw-font-normal form-control notes-input-field"
          @keyup.enter="hasChanged(value.item)"
          @blur="hasChanged(value.item)"
        />
      </div>
      <!--
 <span class="tw-text-[13px] tw-text-[#231F20]">
        {{ value.item.incidentDescription }}
      </span> 
-->
    </template>

    <template #cell(impact)="value">
      <div
        v-if="!isShowEdit"
        class="tw-text-[13px] tw-text-[#231F20] tw-whitespace-nowrap w-mw-[100px]"
      >
        <span
          :class="`impact-cost-item ${value.item.classImpactName} ${value.item.bgImpactName}`"
        >
          {{ getImpactFormId(value.item.incidentImpactLevelId) }}
        </span>
      </div>
      <BaseDropDown
        v-else
        :id="'impactIncidenAndEventTable'"
        :model-value="value.item.incidentImpactLevelId"
        :data="impactDropdownData"
        :class-name="`gray-dropdown-container tw-h-[44px] is-inciden-event-table`"
        :class-text-name="value.item.classImpactName"
        ><BaseDropDownItem
          v-for="(item, index) in impactDropdownData"
          :id="item.id.toString()"
          :key="index"
          :data="item"
          :text="item.name"
          :class-name="`normal-dropdown-container ${
            item.id
              ? `${CHECKLIST_IMPACT_VALUE_WITH_COLOR[`${item.id}`]}`
              : 'tw-text-[#231F20]'
          }`"
          @click="handleScoreSeclected(item, SCORE_TYPE.IMPACT, value.item)"
        />
      </BaseDropDown>
    </template>

    <template #cell(cost)="value">
      <div
        v-if="!isShowEdit"
        class="tw-text-[13px] tw-text-[#231F20] tw-whitespace-nowrap tw-min-h-[20px] w-mw-[100px]"
      >
        <span
          :class="`impact-cost-item ${value.item.classCostName} ${value.item.bgCostName}`"
        >
          {{ getCostFormId(value.item.incidentCostId) }}
        </span>
      </div>
      <BaseDropDown
        v-else
        :id="'impactIncidenAndEventTable'"
        :model-value="value.item.incidentCostId"
        :data="costDropdownData"
        :class-name="`gray-dropdown-container tw-h-[44px] is-inciden-event-table`"
        :class-text-name="value.item.classCostName"
        ><BaseDropDownItem
          v-for="(item, index) in costDropdownData"
          :id="item.id.toString()"
          :key="index"
          :data="item"
          :text="item.name"
          :class-name="`normal-dropdown-container ${
            item.id
              ? `${CHECKLIST_ICON_VALUE_WITH_COLOR[`${item.id}`]}`
              : 'tw-text-[#231F20]'
          }`"
          @click="handleScoreSeclected(item, SCORE_TYPE.COST, value.item)"
        />
      </BaseDropDown>
    </template>

    <template #cell(notes)="value">
      <div class="tw-flex tw-gap-[10px]">
        <span
          v-if="!isShowEdit"
          class="tw-text-[13px] tw-text-[#231F20] tw-min-h-[20px]"
        >
          {{ value.item.incidentMitigations }}
        </span>
        <input
          v-else
          v-model="value.item.incidentMitigations"
          type="text"
          class="tw-border tw-border-solid tw-border-[#EFF0F1] tw-p-[12px] tw-pr-[45px] tw-text-[13px] tw-font-normal form-control notes-input-field"
          @keyup.enter="hasChanged(value.item)"
          @blur="hasChanged(value.item)"
        />
      </div>
    </template>

    <template v-if="isShowEdit" #cell(actions)="value">
      <div
        class="tw-flex tw-justify-end tw-cursor-pointer"
        @click="removeItem(value.item)"
      >
        <img class="tw-w-6 tw-h-6" src="@/assets/img/subCircle.svg" alt="sub" />
      </div>
    </template>
  </CustomTable>
</template>

<script lang="ts" setup>
import { getComponentUiText } from "@/utils/utilities";
import CustomTable, {
  CustomTableColumn,
} from "@/components/common/customTable.vue";
import { computed, onMounted, ref, watch, watchEffect } from "vue";
import BaseDropDown from "@/components/common/form/baseDropDown.vue";
import {
  CHECKLIST_ICON_VALUE_WITH_BG_COLOR,
  CHECKLIST_ICON_VALUE_WITH_COLOR,
  CHECKLIST_IMPACT_VALUE_WITH_BG_COLOR,
  CHECKLIST_IMPACT_VALUE_WITH_COLOR,
  SCORE_TYPE,
} from "@/utils/constants";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import BaseDropDownItem from "@/components/common/form/baseDropDownItem.vue";
import { ICyberReportIncidents } from "@/interfaces/shares";
import store from "@/store";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import dayjs from "dayjs";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";
import { handleChecklistDataReportSplit } from "@/services/sharing";
import { Checklist } from "@/services/apiRoutes/routes";

const props = defineProps({
  data: {
    type: Array as () => ICyberReportIncidents[],
    required: true,
    default: () => [],
  },
  isLoading: {
    type: Boolean,
    required: false,
  },
  isShowEdit: {
    type: Boolean,
    required: false,
    default: () => false,
  },
  columns: {
    type: Array,
    required: false,
    default: () => [
      "date",
      "event",
      "description",
      "impact",
      "cost",
      "notes",
      "actions",
    ],
  },
  isEdit: {
    type: Boolean,
    required: false,
    default: false,
  },
  isDiscard: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const defaultData = {
  addedByUserId: "",
  dateAdded: "",
  dateUpdated: "",
  incidentCost: "",
  incidentCostId: "",
  incidentDescription: "",
  incidentEndDate: "",
  incidentId: "",
  incidentImpactLevel: "",
  incidentImpactLevelId: "",
  incidentMitigations: "",
  incidentName: "",
  incidentNotes: "",
  incidentStartDate: "",
  incidentType: "",
  incidentTypeId: "",
  isArchived: false,
  updatedByUserId: "",
  hasChanged: false,
};

onMounted(() => {
  EventEmitter.on(EmitterEvents.SHARING_ADD_INCIDENT, () => {
    dataTable.value.push({
      ...defaultData,
      id: `${dayjs().unix()}-${Math.random().toString(36).substr(2, 9)}`,
    });
  });
});

const dataTable = ref([...props.data]);
const isLoadingTable = ref(props.isLoading);
const dataRemoveItem: any = ref([]);

watch(
  () => props.isLoading,
  (value) => {
    isLoadingTable.value = value;
  },
);

const emits = defineEmits([
  "edit-notes",
  "remove-item",
  "update-data",
  "call-api",
]);

const checklistIncidentType = computed(
  () => store.getters["Sharing/getChecklistIncidentType"],
);

const impactDropdownData: any = computed(
  () => store.getters["Sharing/getChecklistImpactLevel"],
);

const costDropdownData: any = computed(
  () => store.getters["Sharing/getChecklistCost"],
);

const currentChecklistReportId = computed(
  () => store.getters["Sharing/getChecklistReportId"],
);

watch(
  () => props.isEdit,
  (value) => {
    if (!value && !props.isDiscard) {
      create();
      callRemoveItem();
    }
  },
);

const create = async () => {
  if (dataTable.value.length === 0) return;
  try {
    await dataTable.value.forEach(async (item) => {
      const cleanParams = Object.fromEntries(
        Object.entries({
          incidentTypeId: item.incidentTypeId,
          impactLevelId: item.incidentImpactLevelId
            ? item.incidentImpactLevelId
            : undefined,
          costId: item.incidentCostId ? item.incidentCostId : undefined,
          startDate: item.incidentStartDate,
          mitigations: item.incidentMitigations,
          description: item.incidentDescription,
        }).filter(([key, value]) => value !== "Invalid date"),
      );

      if (item.incidentId === "") {
        emits("call-api", true);
        Object.keys(cleanParams).forEach(
          (key) =>
            (cleanParams[key] === undefined || cleanParams[key] === "") &&
            delete cleanParams[key],
        );
        await store.dispatch("Sharing/postChecklistIncidents", cleanParams);
      } else if (item.hasChanged) {
        emits("call-api", true);
        await store.dispatch("Sharing/updateChecklistIncidents", {
          id: item.incidentId,
          option: cleanParams,
        });
      }
    });
    setTimeout(async () => {
      isLoadingTable.value = true;
      handleChecklistDataReportSplit(
        Checklist.getChecklistReportDataIncidents,
        currentChecklistReportId.value,
      );
      isLoadingTable.value = false;
    }, 500);
  } catch (error) {
    console.log("error", error);
  } finally {
    setTimeout(() => {
      emits("call-api", false);
    }, 1000);
  }
};

const callRemoveItem = async () => {
  await dataRemoveItem.value.forEach(async (item) => {
    if (item.incidentId) {
      await store.dispatch("Sharing/updateChecklistIncidents", {
        id: item.incidentId,
        option: {
          isArchived: true,
        },
      });
    }
  });
  dataRemoveItem.value = [];
};

const updateValue = (data, idDataTable, type) => {
  const index = dataTable.value.findIndex((item) => {
    if (item.incidentId === "") {
      return item.id === idDataTable.id;
    } else {
      return item.incidentId === idDataTable.incidentId;
    }
  });
  dataTable.value[index][type] = data;
  dataTable.value[index].hasChanged = true;
};

const hasChanged = (idDataTable) => {
  const index = dataTable.value.findIndex((item) => {
    if (item.incidentId === "") {
      return item.id === idDataTable.id;
    } else {
      return item.incidentId === idDataTable.incidentId;
    }
  });
  dataTable.value[index].hasChanged = true;
};

const getEventFormId = (id) => {
  return checklistIncidentType.value.find((item) => item.id === id)?.name;
};

const handleScoreSeclected = (event: IDropDownData, scoreType, idDataTable) => {
  const index = dataTable.value.findIndex((item) => {
    if (item.incidentId === "") {
      return item.id === idDataTable.id;
    } else {
      return item.incidentId === idDataTable.incidentId;
    }
  });

  const score = event.id
    ? scoreType === SCORE_TYPE.IMPACT
      ? CHECKLIST_IMPACT_VALUE_WITH_COLOR[`${event.id}`]
      : CHECKLIST_ICON_VALUE_WITH_COLOR[`${event.id}`]
    : "tw-text-[#231F20]";
  const bgScore = event.id
    ? scoreType === SCORE_TYPE.IMPACT
      ? CHECKLIST_IMPACT_VALUE_WITH_BG_COLOR[`${event.id}`]
      : CHECKLIST_ICON_VALUE_WITH_BG_COLOR[`${event.id}`]
    : "tw-bg-[rgba(72,160,255, 0.15)";
  switch (scoreType) {
    case SCORE_TYPE.IMPACT:
      dataTable.value[index].classImpactName = score;
      dataTable.value[index].bgImpactName = bgScore;
      dataTable.value[index].incidentImpactLevelId = event.id;
      break;
    case SCORE_TYPE.COST:
      dataTable.value[index].classCostName = score;
      dataTable.value[index].bgCostName = bgScore;
      dataTable.value[index].incidentCostId = event.id;
      break;
  }
  dataTable.value[index].hasChanged = true;
};

const getCostFormId = (id) => {
  return costDropdownData.value.find((item) => item.id === id)?.name;
};

const getImpactFormId = (id) => {
  return impactDropdownData.value.find((item) => item.id === id)?.name;
};

// format date to dd-mmm-yyyy
const formatDate = (date) => {
  return convertUTCTimeToLocalTime(date);
};

// format date to yyyy-mm-dd
const formatDateInput = (date) => {
  return dayjs(date).format("YYYY-MM-DD");
};
const processData = (data) => {
  const newVal = data || props.data;
  dataTable.value = newVal?.map((item) => {
    const scoreImpact = item.incidentImpactLevelId
      ? CHECKLIST_IMPACT_VALUE_WITH_COLOR[`${item.incidentImpactLevelId}`]
      : "tw-text-[#231F20]";
    const scoreCost = item.incidentCostId
      ? CHECKLIST_ICON_VALUE_WITH_COLOR[`${item.incidentCostId}`]
      : "tw-text-[#231F20]";
    const bgImpact = item.incidentImpactLevelId
      ? CHECKLIST_IMPACT_VALUE_WITH_BG_COLOR[`${item.incidentImpactLevelId}`]
      : "tw-text-[#231F20]";
    const bgCost = item.incidentCostId
      ? CHECKLIST_ICON_VALUE_WITH_BG_COLOR[`${item.incidentCostId}`]
      : "tw-text-[#231F20]";
    return {
      ...item,
      classImpactName: scoreImpact,
      classCostName: scoreCost,
      bgCostName: bgCost,
      bgImpactName: bgImpact,
      incidentStartDate: formatDateInput(item.incidentStartDate),
    };
  });
};

onMounted(() => {
  processData(dataTable.value);
});

watchEffect(() => {
  if (props.data) {
    processData([...props.data]);
  }
});

const removeItem = async (item) => {
  dataRemoveItem.value.push(item);
  dataTable.value = dataTable.value.filter((e: any) => {
    if (e.id) {
      return e.id !== item.id;
    } else {
      return e.incidentId !== item.incidentId;
    }
  });
};

const columnsTableFields = computed<CustomTableColumn[]>(() => {
  return [
    {
      text: getComponentUiText(
        "app-report-achievements-and-progress-table-date-header-title-1",
      ),
      value: "date",
      headerClass:
        "!tw-text-[#ffffff] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase tw-w-[155px]",
      valueClass:
        "tw-text-[#231F20] tw-text-[13px] tw-font-medium tw-w-[155px]",
      sortable: false,
      sortDefault: false,
    },
    {
      text: getComponentUiText(
        "app-share-cyber-profile-incidents-and-events-table-event-header-title-1",
      ),
      value: "event",
      headerClass:
        "!tw-text-[#ffffff] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase",
      valueClass: "tw-text-[#231F20] tw-text-[13px] tw-font-normal tw-w-[25%]",
    },
    {
      text: getComponentUiText(
        "app-share-cyber-profile-incidents-and-events-table-description-header-title-1",
      ),
      value: "description",
      headerClass:
        "!tw-text-[#ffffff] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase",
      valueClass: "tw-text-[#231F20] tw-text-[13px] tw-font-normal tw-w-[20%]",
    },
    {
      text: getComponentUiText(
        "app-share-cyber-profile-incidents-and-events-table-impact-header-title-1",
      ),
      value: "impact",
      headerClass:
        "!tw-text-[#ffffff] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase",
      valueClass: "tw-text-[#231F20] tw-text-[13px] tw-font-normal tw-w-[10%]",
    },
    {
      text: getComponentUiText(
        "app-share-cyber-profile-incidents-and-events-table-cost-header-title-1",
      ),
      value: "cost",
      headerClass:
        "!tw-text-[#ffffff] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase",
      valueClass: "tw-text-[#231F20] tw-text-[13px] tw-font-normal tw-w-[10%]",
    },
    {
      text: getComponentUiText(
        "app-share-cyber-profile-incidents-and-events-table-mitigations-and-actions-header-title-1",
      ),
      value: "notes",
      headerClass:
        "!tw-text-[#ffffff] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase",
      valueClass: "tw-text-[#231F20] tw-text-[13px] tw-font-normal tw-w-[20%]",
    },
    {
      text: "",
      value: "actions",
      valueClass:
        "tw-text-[#231F20] tw-text-[13px] tw-font-normal !tw-pl-[14px] !tw-pr-[23px]",
    },
  ].filter((item) => props.columns.includes(item.value));
});
</script>
<style lang="scss" scoped>
.notes-input-field {
  background: var(--UI-rule-50, rgba(239, 240, 241, 0.5)) !important;
  border: 1px solid var(--UI-rule, #eff0f1);
  padding: 12px;
  border-radius: 6px;
  height: 44px;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

:deep(.table-row) {
  height: 46px;
  min-height: 46px;
}

:deep(.table-header) {
  background-color: #211f58 !important;
}

.input-date-item {
  padding: 12px;
  align-items: center;
  gap: 10px;
  border-radius: 6px;
  border: 1px solid var(--UI-rule, #eff0f1);
  background: #eff0f180;
  height: 44px;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: var(--UI-dark, #231f20);
  border-radius: 6px;
  background: var(--UI-rule-50, rgba(239, 240, 241, 0.5));
  input[type="date"]::-webkit-calendar-picker-indicator {
    height: 15px;
  }
}
.impact-cost-item {
  display: inline-flex;
  padding: 3px 5px;
  justify-content: center;
  align-items: center;
  gap: 5px;
  border-radius: 4px;
  font-weight: 500;
  height: 23px;
}
</style>
